document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-trigger-submit="true"]').forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault(); // Empêche tout comportement par défaut
            const submitInput = document.querySelector('.mm-contact-submit-input');
            if (submitInput) {
                submitInput.click();
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    var selectElement = document.getElementById('contact-reason');

    // Fonction pour vérifier la sélection et ajuster l'opacité
    function updateOpacity() {
        if (selectElement.value === "") {
            selectElement.classList.add('mm-placeholder-selected'); // Ajouter la classe si placeholder sélectionné
        } else {
            selectElement.classList.remove('mm-placeholder-selected'); // Retirer la classe si option valide sélectionnée
        }
    }

    // Écouter l'événement change pour détecter un changement de sélection
    selectElement.addEventListener('change', updateOpacity);

    // Vérifier l'état au chargement de la page
    updateOpacity();
});


/*********************************************************************************************
 * Handle contact form submission and display success message.
 */
document.addEventListener('DOMContentLoaded', function () {
    // Récupérer l'URL actuelle
    const url = new URL(window.location.href);

    // Récupérer les paramètres de l'URL
    const params = url.searchParams;

    // Vérifier si le paramètre 'contact_posted' existe et est égal à 'true'
    if (params.get('contact_posted') === 'true') {
        console.log('Le paramètre contact_posted=true est présent dans l\'URL.');
      const successMessage = document.querySelector('.mm-form-success-message');
        successMessage.classList.remove('mm-none'); // Affiche le message
        successMessage.classList.add('mm-block'); // Ajoutez une classe pour le style (optionnel)
    }

        // Gestion du paramètre 'product' pour le champ caché
    const productParam = params.get('product');
    if (productParam) {
        console.log('Paramètre product détecté:', productParam);

        // Si le champ caché n'existe pas côté serveur, on peut le créer côté client
        const existingHiddenField = document.querySelector('input[name="contact[product]"]');
        if (!existingHiddenField) {
            // Créer le champ caché côté client si nécessaire
            const form = document.querySelector('form[action*="/contact"]');
            if (form) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = 'contact[product]';
                hiddenField.value = productParam; // On utilise le handle comme valeur par défaut
                form.insertBefore(hiddenField, form.firstChild);
                console.log('Champ caché créé côté client avec la valeur:', productParam);
            }
        } else {
            console.log('Champ caché existant côté serveur avec la valeur:', existingHiddenField.value);
        }
    } else {
        console.log('Aucun paramètre product détecté dans l\'URL');
    }
});
